type IPagePattern = {
  [key: string]: string;
};

interface urlRegexConfKey {
  urlRegex: string[];
  btmFullCode: string;
  pagePath: string[];
}

function formatPagePath(pagePath: string) {
  return `${pagePath.replace(/:id/g, '([^/]+)')}(\\?.*)?$`;
}

export function sortObjectByKeyLength(obj: IPagePattern): IPagePattern {
  const sortedKeys = Object.keys(obj).sort((a, b) => b.length - a.length);

  const sortedObject: IPagePattern = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });

  return sortedObject;
}

export function getFormatPagePattern(obj: urlRegexConfKey[], btmAId: string): IPagePattern {
  const newPagePattern: Record<string, string> = {};
  obj.forEach(({ urlRegex, pagePath, btmFullCode }) => {
    if (btmFullCode.indexOf(btmAId) !== -1) {
      if (urlRegex.length !== 0) {
        for (const patteren of urlRegex) {
          newPagePattern[patteren] = btmFullCode;
        }
      } else {
        for (const patteren of pagePath) {
          newPagePattern[formatPagePath(patteren)] = btmFullCode;
        }
      }
    }
  });
  return sortObjectByKeyLength(newPagePattern);
}
